/**
 * B2-RIDE - OpenAPI 3.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 2.0.0
 * Contact: mobile@pikyrent.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { DriverMetadata } from './driverMetadata';

export interface DriverData { 
    id?: number;
    status?: DriverData.StatusEnum;
    licenseCode?: string;
    licenseReleasedBy?: string;
    licenseExpiryDate?: string;
    pathFrontPhotoFile?: string;
    pathBackPhotoFile?: string;
    pathSelfiePhotoFile?: string;
    userId?: number;
    mit_attempt?: number;
    driverMetadata?: DriverMetadata;
    created_at?: Date;
    updated_at?: Date;
}
export namespace DriverData {
    export type StatusEnum = 'Accepted' | 'Pending' | 'Rejected' | 'NotPresent';
    export const StatusEnum = {
        Accepted: 'Accepted' as StatusEnum,
        Pending: 'Pending' as StatusEnum,
        Rejected: 'Rejected' as StatusEnum,
        NotPresent: 'NotPresent' as StatusEnum
    };
}